<template>
  <v-text-field
    style="text-align:right"
    :label="label"
    :disabled="disabled"
    :rules="rules"
    :maxlength="maxlength"
    variant="outlined"
    color="primary"
    class="custom-text-field rtl-input"
    v-bind="$attrs"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'CustomTextField',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 11,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['input', 'change'],
}
</script>

<style scoped>
* {
  direction: rtl !important;
}

.custom-text-field {
  font-size: 1rem;
  width: 100% !important;
  /* height: 50px; */
  border-radius: 12px !important;
  text-align: right;
}

.custom-text-field .v-input__control .v-field .v-field__field {
  direction: rtl !important;
}

.rtl-input :deep(input) {
  direction: rtl !important;
  text-align: right !important;
}
</style>